import {Routes} from '@angular/router';
import {Page404} from './shared/page-404/page-404';
import {AppGuard} from './shared/guards/app-guard';
import {AdminGuard} from './auth/guards/admin-guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/features.routes').then(m => m.routes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.routes),
    canActivate: [AppGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.routes),
    canActivate: [AdminGuard]
  },
  {
    path: 'page-404',
    component: Page404,
    title: '404 | Blinth'
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/page-404'
  }
];
